var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div><strong>{{vm.taskLog.tl_data.msg}}</strong><dias-task-log-progress progress=\"vm.taskLog.tl_data.progress\" status=\"vm.taskLog.tl_status\"></dias-task-log-progress></div>");;return buf.join("");
}